export const localStores = {
    currentStore: null
}
